'use client'

import { Box, type BoxProps } from '@mantine/core'

import { useIntersection } from '@/hooks/useIntersection'

import styles from './style.module.css'

export interface FadeInUpBoxProps extends BoxProps {
  children: React.ReactNode
  threshold?: number
  delay?: number
}

export const FadeInUpBox = ({
  threshold = 0.3,
  delay = 200,
  className,
  ...boxProps
}: FadeInUpBoxProps) => {
  const { elementRef, hasIntersected } = useIntersection<HTMLDivElement>({
    threshold,
    delay,
  })

  return (
    <Box
      ref={elementRef}
      className={`${styles.fadeInUpBox} ${hasIntersected ? styles.visible : ''} ${className ?? ''}`}
      {...boxProps}
    />
  )
}

export default FadeInUpBox
